<template>
    <div class="skeleton" :style>
        <SazkaASpinLoader v-if="spinLoader" />
    </div>
</template>

<script lang="ts" setup>
import SazkaASpinLoader from "@/shared/components/atoms/SazkaSpinLoader.vue";
import { computed } from "vue";

interface SkeletonProps {
    width?: string;
    height?: string;
    borderRadius?: string;
    spinLoader?: boolean;
    noStyles?: boolean;
}

const props = withDefaults(defineProps<SkeletonProps>(), { width: "100%", height: "100%", borderRadius: "12px" });

const style = computed(() => {
    if (props.noStyles) return null;

    return {
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius,
    };
});
</script>
